import axios from "axios";
import { API } from "./api";

// Reuse the same host-aware base URL as the regular api client so admin
// requests are also same-origin in production (avoids cross-origin CORS).
export const ADMIN_API = `${API.replace(/\/api$/, "")}/api/admin`;
const ADMIN_TOKEN_KEY = "cf_admin_token";

export const setAdminToken = (t) => {
  if (t) localStorage.setItem(ADMIN_TOKEN_KEY, t);
  else localStorage.removeItem(ADMIN_TOKEN_KEY);
};
export const getAdminToken = () => localStorage.getItem(ADMIN_TOKEN_KEY);

export const adminApi = axios.create({ baseURL: ADMIN_API });
adminApi.interceptors.request.use((config) => {
  const t = getAdminToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});
